// extracted by mini-css-extract-plugin
export default {"container":"ResetPasswordPage_container__Nacu7","width":"ResetPasswordPage_width__JtUMX"};